import {useState} from 'react';
import {NextPage} from 'next';

import {Screen} from '#component/base';
import {ModalRoot} from '#component/base/Modal';
import {IntroModal} from '#component/page/Survey/component';
import {Wizard} from '#component/partial';
import {WizardProps} from '#component/partial/Wizard/Wizard.types';
import {withRequireUserState} from '#component/util/RequireUserState/RequireUserState';
import {sprinkles} from '#style/sprinkles';

import {useSurvey} from './useSurvey';

export const SurveyScreen = () => {
  const [open, setOpen] = useState(true);
  const {survey, loading, handleSubmit} = useSurvey();
  const {id: surveyId, key: surveyKey} = survey || {};

  return (
    <Screen
      className={sprinkles({bg: 'backgroundGradient'})}
      contentContainerClassName={sprinkles({
        dir: 'col',
        flex: 'flex',
        items: ['start', 'center'],
      })}
      hideHeader
      loading={!survey || loading}
      pageName="Survey"
      pageData={{surveyId, surveyKey}}>
      <ModalRoot onOpenChange={setOpen} open={open}>
        {!open && <Wizard survey={survey as WizardProps['survey']} onSubmit={handleSubmit} />}
        <IntroModal surveyId={surveyId} />
      </ModalRoot>
    </Screen>
  );
};

export const Survey: NextPage = withRequireUserState(SurveyScreen, {userState: 'verified'});
